import { render, staticRenderFns } from "./share_dialog.vue?vue&type=template&id=de526510&scoped=true"
import script from "./share_dialog.vue?vue&type=script&lang=js"
export * from "./share_dialog.vue?vue&type=script&lang=js"
import style0 from "./share_dialog.vue?vue&type=style&index=0&id=de526510&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de526510",
  null
  
)

export default component.exports